import {
  Button,
  CircularProgress,
  FormControl,
  FormHelperText,
  TextField,
  Tooltip,
} from "@mui/material";
import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import moment from "moment";
import {
  add_program_workout_api,
  update_program_workout_api,
} from "src/DAL/programmeWorkout/programmeWorkout";
import WorkoutExercisesUI from "../Workout/WorkoutExercisesUI";
import WorkoutExercisesUILogedClient from "./WorkoutExercisesUILogedClient";
import FoodMattersAndMindsetUI from "../FoodMattersLibrary/FoodMattersAndMindsetUI";
import { convertToTitleCase } from "src/utils/convertHtml";
import AnswerdFoodMattersAndMindsetUI from "./AnswerdFoodMattersAndMindsetUI";
import {
  exercise_obj,
  generateExerciseArray,
  getValidMealArray,
  handleScrollCalled,
  mapExercise,
  urlPatternValidation,
} from "src/utils/constant";
import { s3baseUrl } from "src/config/config";
import NotePopup from "./NotePopup";
import ScheduleWorkouts from "./ScheduleWorkouts";
import QuestionAddOrUpdate from "../MindSetLibrary/QuestionAddOrUpdate";
import QuestionWithAnswers from "../MindSetLibrary/QuestionWithAnswers";
import CustomPopoverNew from "src/components/CustomPopoverNew";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
  customInput: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "0px",

      "& fieldset": {
        border: "none",
      },
    },
  },
}));

const AddWorkoutCalender = forwardRef((props, ref) => {
  const [practiceType, setPracticeType] = useState(props.practice_type);
  const [file, setImage] = React.useState();
  const [imageStatus, setImageStatus] = useState(false);
  const [oldImage, setOldImage] = useState();
  const [mealArray, setMealArray] = useState([]);
  const [targrtDay, setTargrtDay] = useState("regular");
  const [inputs, setInputs] = useState({
    video_url: "",
    image: "",
    meals: [],
    workout_note: "",
    comment: "",
  });
  let check_type =
    props.practice_type === "food" || props.practice_type === "mindset";
  const [open, setOpen] = useState(false);
  const [addArray, setaddArray] = useState([
    { ...exercise_obj("", "", check_type ? "something_else" : "") },
  ]);
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [workoutTitle, setWorkoutTitle] = useState("");
  const classes = useStyles();
  const [isFocused, setIsFocused] = useState(false);
  const [isFocused1, setIsFocused1] = useState(false);
  const [workoutDescription, setWorkoutDescription] = useState("");
  const [isPastedWorkouts, setIsPastedWorkouts] = useState(false);
  const [selectedDay, setSelectedDay] = useState([]);
  const [selectedDate, setSelectedDate] = useState([]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAdd = () => {
    let list = addArray;
    list.splice(addArray.length, 0, {
      ...exercise_obj(),
    });
    setaddArray([...list]);
    props?.setIsLoading(false);
  };

  useImperativeHandle(ref, () => ({
    childButtonClick() {
      handleSubmit();
    },
    childButtonClick2() {
      handleSubmit().then((formDataObject) => {
        if (formDataObject) props.setWorkoutAsTem(formDataObject);
      });
    },
    childButtonClickUpdate() {
      handleSubmitUpdate();
    },
  }));

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const handleFocus1 = () => {
    setIsFocused1(true);
  };

  const handleBlur1 = () => {
    setIsFocused1(false);
  };

  function handleOnDragEnd(result) {
    const items = Array.from(addArray);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setaddArray(items);
  }

  const fileChangedHandler = (e) => {
    setImageStatus(true);
    setImage(URL.createObjectURL(e.target.files[0]));
    setInputs({
      ...inputs,
      ["image"]: e.target.files[0],
    });
  };

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    setIsLoading(true);
    props.setIsLoading(true);

    if (
      urlPatternValidation(inputs.video_url) === false &&
      inputs.video_url != ""
    ) {
      enqueueSnackbar("Enter Valid Video URL", { variant: "error" });
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }

    if (practiceType === "comment" && !inputs.comment.trim()) {
      enqueueSnackbar("Please enter a comment", { variant: "error" });
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }

    if (inputs.video_url == "" && practiceType == "video") {
      enqueueSnackbar("Please Enter Video URL", {
        variant: "error",
      });
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }

    if (inputs.video_url == "" && (inputs.image || oldImage)) {
      enqueueSnackbar("Please Enter Video URL", {
        variant: "error",
      });
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }

    if (inputs.video_url && !inputs.image && !oldImage) {
      enqueueSnackbar("Please Upload Thumbnail", { variant: "error" });
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }

    if (!workoutTitle.trim()) {
      enqueueSnackbar("Please enter a Name", {
        variant: "error",
      });
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }

    if (
      (practiceType === "food" || practiceType === "mindset") &&
      (!addArray?.length || addArray?.[0]?.title?.trim() === "")
    ) {
      enqueueSnackbar("Please enter a Title", { variant: "error" });
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }

    const { exerciesArray, isError } =
      practiceType === "video" ||
      practiceType === "workbook" ||
      practiceType === "comment"
        ? { exerciesArray: [], isError: false }
        : generateExerciseArray(addArray, enqueueSnackbar);

    if (isError) {
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }

    const formDataObject = {
      video_url: inputs.video_url,
      meals: inputs.meals,
      title: workoutTitle,
      workout_type: "",
      description: workoutDescription,
      library_type:
        practiceType === "workbook" ? props?.inputs?.library_type : "",
      questions: props?.questionsToSend || [],
      status: true,
      exercises: exerciesArray,
      difficulty_levels: props?.inputs?.difficulty_levels
        ? props?.inputs?.difficulty_levels?.filter((level) => level)
        : [],
      workout_note: inputs.workout_note,
      program_id: props.programme?._id,
      workout_day: props.day ? props?.day : 1,
      workout_date: moment(props.date).format("YYYY-MM-DD"),
      practice_type:
        props.programme?.program_type == "video"
          ? "video"
          : practiceType
          ? practiceType
          : "workout",
      video_thumbnail: inputs.image || "",
      comment: inputs?.comment,
    };

    const updatedDays = selectedDay.includes(formDataObject.workout_day)
      ? selectedDay
      : [...selectedDay, formDataObject.workout_day];

    const updatedDates = selectedDate.includes(formDataObject.workout_date)
      ? selectedDate
      : [...selectedDate, formDataObject.workout_date];

    const formData = new FormData();

    formData.append("meals", JSON.stringify(formDataObject.meals || []));
    formData.append("target_day", targrtDay || "regular");
    formData.append(
      "video_url",
      formDataObject.video_url ? formDataObject.video_url : "",
    );
    formData.append("title", formDataObject.title);
    formData.append("workout_type", formDataObject.workout_type);
    formData.append("description", formDataObject.description);
    formData.append("status", formDataObject.status);
    formData.append("program_id", formDataObject.program_id);
    formData.append("practice_type", formDataObject.practice_type);
    formData.append("library_type", formDataObject.library_type);
    formData.append("questions", JSON.stringify(formDataObject.questions));
    formData.append(
      "difficulty_levels",
      JSON.stringify(formDataObject.difficulty_levels),
    );
    formData.append("exercises", JSON.stringify(formDataObject.exercises));
    formData.append("workout_note", inputs.workout_note);
    formData.append("comment", inputs?.comment || "");
    formData.append("workout_days", JSON.stringify(updatedDays));
    formData.append("workout_dates", JSON.stringify(updatedDates));
    if (imageStatus) {
      formData.append("video_thumbnail", formDataObject.video_thumbnail);
    }
    if (props.programme?.program_type == "video") {
      formData.append("video_only_type", JSON.stringify(props.multipleTypes));
    }
    const result = await add_program_workout_api(formData);
    if (result.code === 200) {
      setSelectedDate([]);
      setSelectedDay([]);
      props.setMultipleType([]);
      props?.setEditWorkputData(result?.workout);
      handleScrollCalled(result?.workout?._id);
      props.reloadList();
      setIsLoading(false);
      props.setIsLoading(false);
      props.setOpen(false);
      enqueueSnackbar(result.message, { variant: "success" });
      return formDataObject;
    } else {
      setIsLoading(false);
      props.setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleSubmitUpdate = async (e) => {
    if (e) e.preventDefault();
    setIsLoading(true);
    props.setIsLoading(true);

    if (
      urlPatternValidation(inputs.video_url) === false &&
      inputs.video_url != ""
    ) {
      enqueueSnackbar("Enter Valid Video URL", { variant: "error" });
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }

    if (practiceType === "comment" && !inputs.comment.trim()) {
      enqueueSnackbar("Please enter a comment", { variant: "error" });
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }

    if (inputs.video_url == "" && (inputs.image || oldImage)) {
      enqueueSnackbar("Please Enter Video URL", {
        variant: "error",
      });
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }

    if (inputs.video_url && !inputs.image && !oldImage) {
      enqueueSnackbar("Please Upload Thumbnail", { variant: "error" });
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }

    const { exerciesArray, isError } =
      practiceType === "video" ||
      practiceType === "workbook" ||
      practiceType === "comment"
        ? { exerciesArray: [], isError: false }
        : generateExerciseArray(addArray, enqueueSnackbar);

    if (isError) {
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }

    const formDataObject = {
      title: workoutTitle,
      workout_type: "",
      description: workoutDescription,
      status: true,
      exercises: exerciesArray,
      library_type:
        props?.editData?.practice_type === "workbook"
          ? props?.editData?.library_type
          : "",
      questions: props.questionsToSend || [],
      workout_day: props.day ? props?.day : 1,
      workout_date: moment(props?.editData?.workout_date).format("YYYY-MM-DD"),
      video_url: inputs.video_url,
      workout_note: inputs.workout_note,
      meals: inputs.meals,
      video_thumbnail: inputs.image,
    };

    const updatedDays = selectedDay.includes(formDataObject.workout_day)
      ? selectedDay
      : [...selectedDay, formDataObject.workout_day];

    const updatedDates = selectedDate.includes(formDataObject.workout_date)
      ? selectedDate
      : [...selectedDate, formDataObject.workout_date];

    const formData = new FormData();

    formData.append("title", formDataObject.title);
    formData.append("workout_type", formDataObject.workout_type);
    formData.append("practice_type", props?.editData?.practice_type);
    formData.append("description", formDataObject.description);
    formData.append("status", formDataObject.status);
    formData.append("target_day", targrtDay || "regular");
    formData.append("meals", JSON.stringify(formDataObject.meals || []));
    formData.append(
      "video_url",
      formDataObject.video_url ? formDataObject.video_url : "",
    );
    formData.append("library_type", formDataObject.library_type);
    formData.append("questions", JSON.stringify(formDataObject.questions));
    formData.append("exercises", JSON.stringify(formDataObject.exercises));
    formData.append("workout_note", inputs.workout_note);
    formData.append("comment", inputs?.comment || "");
    formData.append("workout_days", JSON.stringify(updatedDays));
    formData.append("workout_dates", JSON.stringify(updatedDates));

    if (imageStatus) {
      formData.append("video_thumbnail", formDataObject.video_thumbnail);
    }

    const result = await update_program_workout_api(
      formData,
      props?.editData?.program_workout_slug,
    );
    if (result.code === 200) {
      if (props?.type === "limited_program") {
        const workout = result?.program_workout;
        let newData = {
          ...workout,
          title: workout?.title,
          color: workout?.program_info?.color,
          workout_color: workout?.program_info?.color,
          workout_title: workout?.title,
          workout_exercises: workout?.exercises,
          workout_program: workout?.program_info,
          status: workout?.status,
          is_deleteAble: workout?.workout_loggers?.length > 0 ? false : true,
          date: moment(workout?.workout_date).format("YYYY-MM-DD"),
          index: props?.events.length - 1,
          open: true,
          editable: workout?.workout_loggers?.length > 0 ? false : true,
          dumyImage: file,
        };
        let list = [...props?.events];
        let indexToUpdate = list.findIndex((item) => item._id === newData?._id);

        if (indexToUpdate !== -1) {
          list[indexToUpdate] = newData;
        }
        enqueueSnackbar(result.message, { variant: "success" });

        props?.setEvents(list);
        handleScrollCalled(workout?._id);
      } else {
        props?.reloadList(props?.editData?._id, result.message);
      }

      setIsLoading(false);
      props.setIsLoading(false);
      props.setOpen(false);
      return formDataObject;
    } else {
      setIsLoading(false);
      props.setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  useEffect(() => {
    if (props?.editData) {
      setInputs({
        ...inputs,
        ["video_url"]: props?.editData?.video_url,
        ["meals"]: getValidMealArray(props?.editData?.meals),
        ["workout_note"]: props?.editData?.workout_note || "",
        ["comment"]: props?.editData?.comment || "",
      });

      setMealArray(getValidMealArray(props?.editData?.meals));
      setTargrtDay(props?.editData?.target_day || "regular");

      setOldImage(props?.editData?.video_thumbnail?.thumbnail_1);
      setPracticeType(props?.editData?.practice_type);
      setWorkoutTitle(
        props?.editData?.workout_title
          ? props?.editData?.workout_title
          : props?.editData?.title,
      );
      setWorkoutDescription(props?.editData?.description);
      const mappedExercises =
        props?.editData?.exercises?.map(mapExercise) || [];
      setaddArray(mappedExercises);
    }
  }, [props?.editData]);

  useEffect(() => {
    if (
      props?.editData?.practice_type == "video" ||
      props?.editData?.practice_type == "workbook" ||
      props?.editData?.practice_type == "comment"
    ) {
      props?.setIsLoading(false);
    } else if (!addArray.length > 0) {
      props?.setIsLoading(true);
    }
  }, [addArray]);

  if (isLoading === true && !props?.editData?.practice_type == "food") {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  const renderLoggedComponents = () => {
    const commonProps = {
      addArray,
      setaddArray,
      setModalChangeExe: props.setModalChangeExe,
      message: "Because member have responded, that is why you can't edit it.",
    };

    switch (practiceType) {
      case "workout":
        return <WorkoutExercisesUILogedClient {...commonProps} />;
      case "video":
        return null;
      case "comment":
        return (
          <Tooltip placement="top" title={commonProps.message}>
            <div className="row my-3">
              <div className="col-12">
                <TextField
                  id="comment-text-logged"
                  label="Add Your Comment Here"
                  variant="outlined"
                  fullWidth
                  multiline
                  rows={6}
                  name="comment"
                  value={inputs.comment}
                  InputProps={{ readOnly: true }}
                  disabled
                />
              </div>
            </div>
          </Tooltip>
        );
      case "workbook":
        return (
          <QuestionWithAnswers
            questionsToSend={props.questionsToSend}
            setQuestionsToSend={props.setQuestionsToSend}
            editShow={props.editShow}
            setEditShow={props.setEditShow}
            is_show_only={true}
            message={commonProps.message}
          />
        );
      default:
        return (
          <AnswerdFoodMattersAndMindsetUI
            {...commonProps}
            meals_data={props}
            mainindex={0}
          />
        );
    }
  };

  const renderEditableComponents = () => {
    if (addArray.length > 0) {
      switch (practiceType) {
        case "workout":
          return (
            <WorkoutExercisesUI
              addArray={addArray}
              setaddArray={setaddArray}
              setModalChangeExe={props.setModalChangeExe}
            />
          );
        case "video":
          return null;
        case "comment":
          return (
            <div className="row my-3">
              <div className="col-12">
                <TextField
                  id="comment-text"
                  label="Write your comment here"
                  placeholder="Write your comment here"
                  variant="outlined"
                  fullWidth
                  multiline
                  rows={6}
                  name="comment"
                  value={inputs.comment}
                  onChange={(e) => {
                    setInputs({ ...inputs, comment: e.target.value });
                    props.setModalChangeExe(true);
                  }}
                  InputProps={{
                    readOnly: hasLogged ? true : false,
                  }}
                />
              </div>
            </div>
          );
        case "workbook":
          return (
            <QuestionAddOrUpdate
              questionsToSend={props.questionsToSend}
              setQuestionsToSend={props.setQuestionsToSend}
              editShow={props.editShow}
              setEditShow={props.setEditShow}
              editData={props.editData}
            />
          );
        default:
          return (
            <FoodMattersAndMindsetUI
              addArray={addArray}
              setaddArray={setaddArray}
              setModalChangeExe={props.setModalChangeExe}
              mainindex={0}
              inputs_meals={inputs}
              mealArray={mealArray}
              setMealArray={setMealArray}
              targrtDay={targrtDay}
              setTargrtDay={setTargrtDay}
              practiceType={practiceType}
              isLoading={isLoading}
            />
          );
      }
    } else {
      switch (practiceType) {
        case "video":
          return null;
        case "comment":
          return (
            <div className="row my-3">
              <div className="col-12">
                <TextField
                  id="comment-text"
                  label="Write your comment here"
                  placeholder="Write your comment here"
                  variant="outlined"
                  fullWidth
                  multiline
                  rows={6}
                  name="comment"
                  value={inputs.comment}
                  onChange={(e) => {
                    setInputs({ ...inputs, comment: e.target.value });
                    props.setModalChangeExe(true);
                  }}
                  InputProps={{
                    readOnly: hasLogged ? true : false,
                  }}
                />
              </div>
            </div>
          );
        case "workbook":
          return (
            <QuestionAddOrUpdate
              questionsToSend={props.questionsToSend}
              setQuestionsToSend={props.setQuestionsToSend}
              editShow={props.editShow}
              setEditShow={props.setEditShow}
              editData={props.editData}
            />
          );
        default:
          return (
            <div className="text-end container my-4">
              <button className="small-contained-button" onClick={handleAdd}>
                Add Exercise
              </button>
            </div>
          );
      }
    }
  };

  const hasLogged = props?.editData?.workout_loggers?.length > 0;

  return (
    <div>
      <div className="row">
        <div className="col-12 col-md-8">
          <FormControl className={!isFocused ? classes.customInput : ""}>
            <TextField
              id="outlined-basic"
              variant={"outlined"}
              onFocus={handleFocus}
              className="title-Test"
              onBlur={handleBlur}
              placeholder={`${convertToTitleCase(practiceType)} Name !`}
              value={workoutTitle}
              name="workoutTitle"
              onChange={(e) => {
                if (e.target.value.length <= 30) {
                  setWorkoutTitle(e.target.value);
                  props.setModalChangeExe(true);
                }
              }}
              InputLabelProps={{
                shrink: true,
                style: { fontSize: "18px" },
              }}
              InputProps={{
                readOnly: hasLogged ? true : false,
                style: {
                  fontSize: "32px",
                  fontWeight: "500",
                },
              }}
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
                fontSize: "13px",
              }}
            />
          </FormControl>
          <FormControl
            fullWidth
            className={!isFocused1 ? classes.customInput : ""}
          >
            <TextField
              id="outlined-basic"
              className="desc-Test"
              variant={"outlined"}
              onFocus={handleFocus1}
              onBlur={handleBlur1}
              placeholder={`${convertToTitleCase(practiceType)} description !`}
              value={workoutDescription}
              multiline
              rows={3}
              name="workoutTitle"
              onChange={(e) => {
                if (e.target.value.length <= 250)
                  setWorkoutDescription(e.target.value);
                props.setModalChangeExe(true);
              }}
              InputLabelProps={{
                shrink: true,
                style: { fontSize: "18px" },
              }}
              InputProps={{
                readOnly: hasLogged ? true : false,

                style: {
                  fontSize: "14px",
                  fontWeight: "500",
                  padding: 0,
                },
                maxLength: 10,
              }}
              sx={{
                borderRadius: "5px",

                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
                mb: 1,
              }}
            />
          </FormControl>
        </div>
        <div className="col-12 col-md-4 text-end mt-3 mt-md-0">
          {props?.programme?.program_length_type === "unlimited" &&
          (props?.practice_type === "workout" ||
            props?.editData?.practice_type === "workout") ? (
            <button
              className="small-contained-button "
              onClick={() => {
                handleOpen();
              }}
            >
              Add Admin Note
            </button>
          ) : (
            ""
          )}
          {!props.editData && (
            <button
              className="small-contained-button ms-2"
              onClick={() => {
                setIsPastedWorkouts(true);
              }}
            >
              Schedule Workout
            </button>
          )}
        </div>
      </div>
      {practiceType !== "comment" && (
        <>
          {hasLogged ? (
            <div className="row my-3">
              <div className="col-lg-5 col-md-5 col-sm-12 ">
                <Tooltip
                  placement="top"
                  touch="on"
                  title={
                    "Because member have responded, that is why you can't edit it."
                  }
                >
                  <TextField
                    id="outlined-basic"
                    label="Video Url"
                    variant="outlined"
                    fullWidth
                    name="video_url"
                    disabled={hasLogged ? true : false}
                    value={inputs.video_url}
                    onChange={handleChange}
                  />
                </Tooltip>
              </div>
              <div className="col-lg-7 col-md-7 col-sm-12">
                <div className="row w-100 div-style ms-0 pt-0">
                  <div className="col-lg-5 col-md-5 col-sm-12">
                    <p className="mb-0">Upload Video Thumbnail </p>
                    <FormHelperText className="pt-0" sx={{ fontSize: 9 }}>
                      Image Size(500 X 500) ("JPG", "JPEG", "PNG","WEBP")
                    </FormHelperText>
                  </div>
                  <div className=" col-lg-2 col-md-2 col-sm-12">
                    {file ? (
                      <img className="image-border" src={file} height="50" />
                    ) : oldImage ? (
                      <img
                        className="image-border"
                        src={s3baseUrl + oldImage}
                        height="50"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-lg-5 col-md-5 col-sm-12  text-lg-end text-md-end text-sm-start pt-2">
                    <Tooltip
                      placement="top"
                      touch="on"
                      title={
                        "Because member have responded, that is why you can't edit it."
                      }
                    >
                      <label htmlFor="contained-button-file">
                        <Button
                          className="small-contained-button"
                          startIcon={<FileUploadIcon />}
                          component="span"
                          variant="contained"
                          size="small"
                          disabled={hasLogged ? true : false}
                        >
                          Upload
                        </Button>
                      </label>
                    </Tooltip>
                  </div>
                </div>
                {inputs?.image?.name == "" ? (
                  ""
                ) : (
                  <p className="text-secondary">{inputs?.image?.name}</p>
                )}
              </div>
            </div>
          ) : (
            <div className="row my-3">
              <div className="col-11 video-text">
                <p>
                  The video URL and the thumbnail image are linked, as adding a
                  video URL requires a thumbnail and vice versa. The thumbnail
                  will appear on the calendar, and clicking it will open the
                  popup.
                </p>
              </div>
              <div className="col-lg-5 col-md-5 col-sm-12 ">
                <TextField
                  id="outlined-basic"
                  label="Video Url"
                  variant="outlined"
                  required={practiceType == "video"}
                  fullWidth
                  name="video_url"
                  disabled={hasLogged ? true : false}
                  value={inputs.video_url}
                  onChange={handleChange}
                />
              </div>
              <div className="col-lg-7 col-md-7 col-sm-12">
                <div className="row w-100 div-style ms-0 pt-0">
                  <div className="col-lg-5 col-md-5 col-sm-12">
                    <p className="mb-0">
                      {practiceType == "video"
                        ? "Upload Video Thumbnail *"
                        : "Upload Video Thumbnail"}{" "}
                    </p>
                    <FormHelperText className="pt-0" sx={{ fontSize: 9 }}>
                      Image Size(500 X 500) ("JPG", "JPEG", "PNG","WEBP")
                    </FormHelperText>
                  </div>
                  <div className=" col-lg-2 col-md-2 col-sm-12">
                    {file ? (
                      <img className="image-border" src={file} height="50" />
                    ) : oldImage ? (
                      <img
                        className="image-border"
                        src={s3baseUrl + oldImage}
                        height="50"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-lg-5 col-md-5 col-sm-12  text-lg-end text-md-end text-sm-start pt-2">
                    <label htmlFor="contained-button-file">
                      <input
                        accept=".jpg, .jpeg, .png, .webp"
                        id="contained-button-file"
                        multiple
                        type="file"
                        name="image"
                        required
                        onChange={(e) => fileChangedHandler(e)}
                        style={{ display: "none" }}
                      />

                      <Button
                        className="small-contained-button"
                        startIcon={<FileUploadIcon />}
                        component="span"
                        variant="contained"
                        size="small"
                        disabled={hasLogged ? true : false}
                      >
                        Upload
                      </Button>
                    </label>
                  </div>
                </div>
                {inputs?.image?.name == "" ? (
                  ""
                ) : (
                  <p className="text-secondary">{inputs?.image?.name}</p>
                )}
              </div>
            </div>
          )}
        </>
      )}
      <DragDropContext
        onDragEnd={handleOnDragEnd}
        className="h-100"
        isDragDisabled={true}
      >
        <Droppable droppableId="characters" isDragDisabled={true}>
          {(provided) => (
            <div
              className="characters"
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {hasLogged
                ? renderLoggedComponents()
                : renderEditableComponents()}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      <NotePopup
        inputs={inputs}
        setInputs={setInputs}
        open={open}
        handleClose={handleClose}
      />
      <CustomPopoverNew
        isOpenPop={isPastedWorkouts}
        isClosePop={setIsPastedWorkouts}
        title="Schedule Workout"
        componentToPassDown={
          <div className="px-4 pb-3">
            <ScheduleWorkouts
              props={props?.date}
              programme={props?.programme}
              selectedDay={selectedDay}
              setSelectedDay={setSelectedDay}
              setSelectedDate={setSelectedDate}
              selectedDate={selectedDate}
              setIsPastedWorkouts={setIsPastedWorkouts}
            />
          </div>
        }
      />
    </div>
  );
});
export default AddWorkoutCalender;
